import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import PhoneIcon from '@material-ui/icons/Phone';
import LogoAvatar from '../../assets/logoAvatar.jpg';
import './topBar.less';

class TopBar extends React.Component {
  componentDidMount() {}

  render() {
    const { openDrawer } = this.props;

    return (
      <AppBar className="top-bar" position="static">
        <Toolbar>
          {!!openDrawer && (
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={openDrawer}>
              <MenuIcon />
            </IconButton>
          )}
          <img className="top-bar-logo" src={LogoAvatar} alt="logo" />
          <Typography variant="h6">
            UNIGAZ
          </Typography>
          <div className="top-bar-phone-number">
            <PhoneIcon />
            <Typography variant="h6">
              32 340 40 42
            </Typography>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

TopBar.propTypes = {
  openDrawer: PropTypes.func,
};

TopBar.defaultProps = {
  openDrawer: undefined,
};

export default TopBar;
